<div class="rejete-screen">

  <div class="grain"></div>
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>

  <div class="card">

    <!-- Wordmark -->
    <div class="wordmark">
      <span class="wordmark-la">La</span>
      <span class="wordmark-base">BASE</span>
    </div>

    <!-- ── CHOICE ─────────────────────────────────────────────────────── -->
    @if (mode() === 'choice') {

      <div class="reject-seal">
        <div class="reject-icon-wrap">
          <ion-icon name="close-circle-outline" class="reject-icon"></ion-icon>
        </div>
      </div>

      <h1 class="heading">Certificat <em>refusé</em></h1>

      @if (rejectionReason) {
        <div class="reason-block">
          <span class="reason-label">Motif de refus</span>
          <span class="reason-text">{{ rejectionReason }}</span>
        </div>
      }

      <p class="subtext">
        Pour accéder à La BASE, validez votre statut étudiant<br>via l'une des options ci-dessous.
      </p>

      <div class="option-list">
        <button class="option-card" (click)="goTo('certificate')">
          <div class="option-icon cert-ico">
            <ion-icon name="document-outline"></ion-icon>
          </div>
          <div class="option-body">
            <span class="option-title">Nouveau certificat</span>
            <span class="option-desc">Déposer un certificat de scolarité</span>
          </div>
          <ion-icon name="chevron-forward-outline" class="option-arrow"></ion-icon>
        </button>

        <button class="option-card" (click)="goTo('email')">
          <div class="option-icon mail-ico">
            <ion-icon name="mail-outline"></ion-icon>
          </div>
          <div class="option-body">
            <span class="option-title">Email universitaire</span>
            <span class="option-desc">Adresse institutionnelle @univ…</span>
          </div>
          <ion-icon name="chevron-forward-outline" class="option-arrow"></ion-icon>
        </button>
      </div>

    }

    <!-- ── CERTIFICATE UPLOAD ─────────────────────────────────────────── -->
    @if (mode() === 'certificate') {

      <button class="back-btn" (click)="goTo('choice')">
        <ion-icon name="arrow-back-outline"></ion-icon> Retour
      </button>

      <h1 class="heading">Nouveau <em>certificat</em></h1>
      <p class="subtext">Votre document sera examiné sous 48h.</p>

      @if (!uploadSuccess()) {

        <div
          class="drop-zone"
          [class.has-file]="selectedFile()"
          [class.drag-over]="isDragOver()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave()"
          (drop)="onDrop($event)"
          (click)="fileInput.click()"
        >
          <input
            #fileInput
            type="file"
            accept=".pdf,.jpg,.jpeg,.png,.webp"
            (change)="onFileChange($event)"
            hidden
          />

          @if (selectedFile()) {
            <div class="file-preview">
              <ion-icon name="document-outline" class="file-ico"></ion-icon>
              <span class="file-name">{{ selectedFile()!.name }}</span>
              <button class="remove-btn" (click)="$event.stopPropagation(); clearFile()">
                <ion-icon name="close-outline"></ion-icon>
              </button>
            </div>
          } @else {
            <ion-icon name="cloud-upload-outline" class="drop-ico"></ion-icon>
            <span class="drop-label">Cliquez ou déposez votre fichier</span>
            <span class="drop-hint">PDF · JPG · PNG · WEBP — max 10 Mo</span>
          }
        </div>

        @if (uploadError()) {
          <p class="field-error">{{ uploadError() }}</p>
        }

        <button
          class="btn-primary"
          [disabled]="!selectedFile() || isUploading()"
          (click)="submitCertificate()"
        >
          @if (isUploading()) {
            <ion-icon name="hourglass-outline"></ion-icon> Envoi en cours…
          } @else {
            <ion-icon name="cloud-upload-outline"></ion-icon> Envoyer le certificat
          }
        </button>

      } @else {

        <div class="success-block">
          <div class="success-circle">
            <ion-icon name="checkmark-outline"></ion-icon>
          </div>
          <p class="success-text">Certificat reçu ! Vous serez notifié dès validation.</p>
        </div>

      }

    }

    <!-- ── EMAIL OTP ──────────────────────────────────────────────────── -->
    @if (mode() === 'email') {

      <button class="back-btn" (click)="emailStep() === 'otp' ? backToEmailInput() : goTo('choice')">
        <ion-icon name="arrow-back-outline"></ion-icon> Retour
      </button>

      @if (emailStep() === 'input') {

        <h1 class="heading">Email <em>universitaire</em></h1>
        <p class="subtext">Renseignez votre adresse institutionnelle.</p>

        <input
          type="email"
          class="email-input"
          placeholder="prenom.nom@univ-example.fr"
          [ngModel]="studentEmail()"
          (ngModelChange)="studentEmail.set($event)"
          (keyup.enter)="sendOtp()"
          autocomplete="email"
        />

        @if (emailError()) {
          <p class="field-error">{{ emailError() }}</p>
        }

        <button class="btn-primary" [disabled]="isSendingOtp()" (click)="sendOtp()">
          @if (isSendingOtp()) {
            <ion-icon name="hourglass-outline"></ion-icon> Envoi du code…
          } @else {
            <ion-icon name="send-outline"></ion-icon> Recevoir le code
          }
        </button>

      }

      @if (emailStep() === 'otp') {

        <h1 class="heading">Code de <em>vérification</em></h1>
        <p class="subtext">
          Code envoyé à<br>
          <strong>{{ studentEmail() }}</strong>
        </p>

        <app-otp-input
          (otpChange)="onOtpChange($event)"
          (otpComplete)="onOtpComplete()">
        </app-otp-input>

        @if (emailError()) {
          <p class="field-error">{{ emailError() }}</p>
        }

        <button class="btn-primary" [disabled]="isVerifyingOtp()" (click)="verifyOtp()">
          @if (isVerifyingOtp()) {
            <ion-icon name="hourglass-outline"></ion-icon> Vérification…
          } @else {
            <ion-icon name="checkmark-outline"></ion-icon> Valider le code
          }
        </button>

      }

    }

    <!-- Logout — toujours visible -->
    <button class="btn-logout" (click)="logout.emit()">
      <ion-icon name="log-out-outline"></ion-icon>
      Se déconnecter
    </button>

  </div>

</div>
